/* @flow */
import * as React from 'react';

import Glyph from 'components/Glyph';
import Message from 'entities/Message';
import Time from 'components/Time';
import Timestamp from 'components/Timestamp';

import './styles/GroupMessageInformation.scss';

type Props = {
  showReadReceipt?: boolean,
  message: Message,
};

export default class GroupMessageInformation extends React.Component<Props> {
  renderTimestamp() {
    const { message } = this.props;
    if (message.getStatus() === 'failed') {
      return (
        <div className="GroupMessageInformation-timestamp">
          <span className="GroupMessageInformation-failed">
            An error has occurred. Please edit your message and send again.
          </span>
        </div>
      );
    }
    let time;
    let date;
    let glyph;
    if (message.getStatus() === 'scheduled') {
      time = <Time date={message.getSendAt()} hour="numeric" minute="2-digit" />;
      date = <Time date={message.getSendAt()} day="numeric" month="long" year="numeric" />;
      glyph = <Glyph className="GroupMessageInformation-clock" name="schedule" size="small" />;
    } else {
      time = <Time date={message.getSentAt()} hour="numeric" minute="2-digit" />;
      date = <Timestamp date={message.getSentAt()} />;
    }
    return (
      <div className="GroupMessageInformation-timestamp">
        {glyph}
        {date}
        {' at '}
        {time}
      </div>
    );
  }

  render() {
    return <div className="GroupMessageInformation">{this.renderTimestamp()}</div>;
  }
}
